import {
  CHECK_ITEM_WISHLIST_STATUS,
  GET_WISHLIST_ITEM_COUNT_BY_USER,
  GET_WISHLIST_ITEMS_BY_CUSTOMER_INFO,
  SAVE_WISHLIST_ITEMS,
  SAVE_WISHLIST_ITEMS_COUNT,
  SET_ITEM_WISHLIST_STATE,
} from '../actionTypes';

export interface WishlistAction {
  type: string;
  data?: any;
  callback?: any;
}

export const setItemWishlistState = (data: any, callback?: any): WishlistAction => {
  return {
    type: SET_ITEM_WISHLIST_STATE,
    data,
    callback,
  };
};

export const getWishlistItemsByCustomerInfo = (
  data: any,
  callback?: any
): WishlistAction => {
  return {
    type: GET_WISHLIST_ITEMS_BY_CUSTOMER_INFO,
    data,
    callback,
  };
};

export const saveWishlistData = (data: any) => {
  return {
    type: SAVE_WISHLIST_ITEMS,
    data,
  };
};

export const checkItemWishlistStatus = (data: any, callback: any) => {
  return {
    type: CHECK_ITEM_WISHLIST_STATUS,
    data,
    callback,
  };
};

export const getWishlistItemCountByUser = (data: any, callback?: any) => {
  return {
    type: GET_WISHLIST_ITEM_COUNT_BY_USER,
    data,
    callback,
  };
};

export const saveWishlistItemCountByUser = (data: any) => {
  return {
    type: SAVE_WISHLIST_ITEMS_COUNT,
    data,
  };
};
